export var EmbedPlatform;
(function (EmbedPlatform) {
    EmbedPlatform["DESKTOP"] = "DESKTOP";
    EmbedPlatform["SAMSUNG"] = "SAMSUNG";
    EmbedPlatform["LG"] = "LG";
    EmbedPlatform["VIZIO"] = "VIZIO";
    EmbedPlatform["COMCAST_FLEX"] = "COMCAST_FLEX";
    EmbedPlatform["COMCAST_X1"] = "COMCAST_X1";
    EmbedPlatform["PS4"] = "PS4";
    EmbedPlatform["XBOX"] = "XBOX";
})(EmbedPlatform || (EmbedPlatform = {}));
